//Library
import { Grid, Menu, MenuItem, Modal, Select } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";

//Components

import { fget } from "../../../API/callsAPI";

//CSS Styles
import { Box, Button } from "@mui/material";
import { DotsThree, PencilLine, Plus, Trash } from "phosphor-react";
import commonStyles from "../../../Utils/commonStyles";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import CreateUpdatePageLayoutModal from "../UpdatePageModals/CreateUpdatePageLayoutModal";
import ProjectUpdates from "../UpdatePageWidgets/ProjectUpdates/ProjectUpdates";
import TaskOverview from "../UpdatePageWidgets/TaskOverview/TaskOverview";
import DelayedTaskWidgetOverview from "../Widgets/DelayedTaskWidget/DelayedTaskWidgetOverview";
import ProjectDeadlineCountdown from "../Widgets/ProjectDeadlineWidgets/ProjectDeadlineCountdown";
import ProjectHealthWidget from "../Widgets/ProjectHealthWidget/ProjectHealthWidget";
import ProjectReviewsWidgetOverview from "../Widgets/ProjectReviewsWidget/ProjectReviewsWidgetOverview";
import SingleTodoComponent from "../Widgets/UpdatesPageTodoWidgets/TodoWidgetsComponents/SingleTodoComponent";
import StorageOverview from "../Widgets/UpdatesPageTodoWidgets/TodoWidgetsComponents/StorageOverview";
import UserScoreWidget from "../Widgets/UserScoreWidget/UserScoreWidget";

import useStyles from "./UpdatesOverview.styles";
import { MovieColabContext } from "../../../Context/MovieColabContext";

function UpdatesOverview(props) {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const { loggedInUser } = useContext(MovieColabContext);
  //States
  const [statusList, setStatusList] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [projectDetails, setProjectDetails] = useState({});
  const [isCreateLayoutModalOpen, setIsCreateLayoutModalOpen] = useState(false);
  const [layouts, setLayouts] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState();
  const [leftSideWidgets, setLeftSideWidgets] = useState([]);
  const [rightSideWidgets, setRightSideWidgets] = useState([]);
  const [isEditLayoutModalOpen, setIsEditLayoutModalOpen] = useState(false);
  const [isDeleteLayoutModalOpen, setIsDeleteLayoutModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //UseEffect
  useEffect(() => {
    fetchUsers();
    getProjectDetails();
    loadSavedLayout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await fget({
        url: `project/${props.project}/users/`,
      });

      setAllUsers(
        res.data.results.map((el) => {
          const data = {
            name: el.first_name + " " + el.last_name,
            id: el.id,
          };
          return data;
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getProjectDetails = async () => {
    try {
      const res = await fget({
        url: `project/${props.project}/`,
      });
      setProjectDetails(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const loadSavedLayout = () => {
    const layoutsFromLocalStorage =
      JSON.parse(localStorage.getItem("layouts")) || [];
    if (layoutsFromLocalStorage.length) {
      setLayouts(layoutsFromLocalStorage);
      setSelectedLayout(
        layoutsFromLocalStorage[layoutsFromLocalStorage?.length - 1].name
      );
    }
  };

  useEffect(() => {
    if (selectedLayout) {
      const layout = layouts.find((el) => el.name === selectedLayout);
      if (layout) {
        const leftSideElements = layout.layout.filter(
          (sin) => sin.column === "left" && sin.isSelected
        );
        setLeftSideWidgets(leftSideElements);
        const rightSideElements = layout.layout.filter(
          (sin) => sin.column === "right" && sin.isSelected
        );
        setRightSideWidgets(rightSideElements);
      }
    }
  }, [selectedLayout]);

  const handleEditLayout = (layout) => {
    setSelectedLayout(layout);
    setIsEditLayoutModalOpen(true);
  };

  const handleDeleteLayout = () => {
    const layouts = JSON.parse(localStorage.getItem("layouts")) || [];
    const filteredLayouts = layouts.filter(
      (layout) => layout.name !== selectedLayout
    );
    localStorage.setItem("layouts", JSON.stringify(filteredLayouts));
    if (filteredLayouts?.length) {
      loadSavedLayout();
    } else {
      setSelectedLayout("");
      setLayouts([]);
    }
    setIsDeleteLayoutModalOpen(false);
  };

  useEffect(() => {
    const getStatusList = async () => {
      try {
        const res = await fget({
          url: `trackables/status/?project=${props.project}`,
        });
        setStatusList(res?.data?.results);
      } catch (error) {
        console.log(error);
      }
    };
    getStatusList();
  }, [props.project]);

  const renderWidget = (widget) => {
    switch (widget.slug) {
      case "project_health":
        return (
          <ProjectHealthWidget
            projectId={props.project}
            projectDetails={projectDetails}
          />
        );
      case "project_reviews":
        return <ProjectReviewsWidgetOverview projectId={props.project} />;
      case "countdown":
        return (
          <ProjectDeadlineCountdown
            completionDate={projectDetails?.completion_date}
          />
        );
      case "delayed_tasks":
        return (
          <DelayedTaskWidgetOverview
            projectId={props.project}
            users={allUsers}
            loggedInUser={loggedInUser}
            projectDetails={projectDetails}
          />
        );
      case "task_overview":
        return (
          <TaskOverview
            projectId={props.project}
            users={allUsers}
            loggedInUser={loggedInUser}
            projectDetails={projectDetails}
          />
        );
      case "my_todos":
        return <SingleTodoComponent projectId={props.project} />;
      case "storage_overview":
        return <StorageOverview />;
      case "user_score":
        return (
          <UserScoreWidget
            projectId={props.project}
            userRoleForProject={props.userRoleForProject}
            loggedInUser={loggedInUser}
          />
        );
      case "storage_overview":
        return <StorageOverview />;
      default:
        return <div>{widget.name}</div>;
    }
  };

  return (
    <div style={{ height: `calc(100vh - 130px)` }}>
      <Grid container spacing={2} style={{ height: "100%" }}>
        {/* <Hidden lgDown> */}
        <Grid item md={8} xl={8} style={{ height: "100%" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <div
              className={classes.hiUserName}
              style={{
                width: "100%",
              }}
            >
              <span className={classes.userName}>Welcome Back,</span>
              <span>{loggedInUser?.name || ""}</span>
            </div>
            <div
              className={commonClasses.flexAndGap8Px}
              style={{
                gap: "16px",
              }}
            >
              <Button
                onClick={() => setIsCreateLayoutModalOpen(true)}
                sx={{ color: "white", minWidth: 0, padding: 0 }}
              >
                <Plus size={22} />
              </Button>
              {layouts?.length ? (
                <>
                  <div className={classes.cardContentDiv2}>
                    <Select
                      style={{ width: "150px", fontSize: "12px" }}
                      disableUnderline
                      className={classes.cardContentInput1}
                      value={selectedLayout}
                      onChange={(e) => setSelectedLayout(e.target.value)}
                    >
                      {layouts?.map((sin) => (
                        <MenuItem value={sin.name} key={sin.name}>
                          {sin.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <Button
                    onClick={handleClick}
                    sx={{ color: "white", minWidth: 0, padding: 0 }}
                  >
                    <DotsThree size={22} />
                  </Button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          {selectedLayout?.length ? (
            <Grid
              container
              spacing={2}
              style={{ height: "100%", overflowY: "auto" }}
            >
              <Grid
                item
                md={6}
                style={{
                  height: "100%",
                  // overflowY: "auto"
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {leftSideWidgets.map((widget, index) => (
                  <Box key={index}>{renderWidget(widget)}</Box>
                ))}
              </Grid>
              <Grid
                item
                md={6}
                style={{
                  height: "100%",
                  // overflowY: "auto"
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {rightSideWidgets.map((widget, index) => (
                  <Box key={index}>{renderWidget(widget)}</Box>
                ))}
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              spacing={2}
              style={{ height: "100%", overflowY: "auto" }}
            >
              <Grid
                item
                md={6}
                style={{
                  height: "99%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <ProjectHealthWidget
                  projectId={props.project}
                  projectDetails={projectDetails}
                />
                <ProjectReviewsWidgetOverview projectId={props.project} />
                <ProjectDeadlineCountdown
                  completionDate={projectDetails?.completion_date}
                />
              </Grid>
              <Grid
                item
                md={6}
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <UserScoreWidget
                  projectId={props.project}
                  userRoleForProject={props.userRoleForProject}
                  loggedInUser={loggedInUser}
                />
                <SingleTodoComponent projectId={props.project} />
                <TaskOverview
                  projectId={props.project}
                  users={allUsers}
                  loggedInUser={loggedInUser}
                  projectDetails={projectDetails}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item md={4} lg={4} xl={4} style={{ height: "100%" }}>
          <ProjectUpdates
            users={allUsers}
            projectId={props.project}
            statusList={statusList}
          />
        </Grid>
      </Grid>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleEditLayout(selectedLayout);
            handleClose();
          }}
        >
          <PencilLine size={25} />{" "}
          <span style={{ marginLeft: "10px" }}>Edit {selectedLayout}</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsDeleteLayoutModalOpen(true);
            handleClose();
          }}
        >
          <Trash size={25} />{" "}
          <span style={{ marginLeft: "10px", color: "red" }}>
            Delete {selectedLayout}
          </span>
        </MenuItem>
      </Menu>
      <Modal
        open={isCreateLayoutModalOpen}
        onClose={() => setIsCreateLayoutModalOpen(false)}
        className={commonClasses.flexCenter}
      >
        <CreateUpdatePageLayoutModal
          type="new"
          handleClose={() => setIsCreateLayoutModalOpen(false)}
          handleUpdate={loadSavedLayout}
        />
      </Modal>
      <Modal
        open={isEditLayoutModalOpen}
        onClose={() => setIsEditLayoutModalOpen(false)}
        className={commonClasses.flexCenter}
      >
        <CreateUpdatePageLayoutModal
          type="edit"
          handleClose={() => setIsEditLayoutModalOpen(false)}
          handleUpdate={loadSavedLayout}
          initialLayout={layouts.find((sin) => sin.name === selectedLayout)}
        />
      </Modal>
      <Modal
        open={isDeleteLayoutModalOpen}
        onClose={() => setIsDeleteLayoutModalOpen(false)}
        className={commonClasses.flexCenter}
      >
        <DeleteModal
          type="layout"
          name={selectedLayout}
          handleCloseDeleteModal={() => {
            setIsDeleteLayoutModalOpen(false);
          }}
          handleDelete={handleDeleteLayout}
        />
      </Modal>
    </div>
  );
}

export default UpdatesOverview;
